<div>
    <h2>Send custom IQ packets:</h2>
    <textarea rows="10" class="form-control" [(ngModel)]="iqRequest"></textarea>
    <button (click)="sendIq()">Send IQ</button>

    <pre><code>{{iqResponse}}</code></pre>
</div>
